import { textColorLevel2, primaryColorAlternative } from '@calendly/ui/theme';
import classNames from 'classnames';
import { forwardRef } from 'react';
const styledSvgCss = "s1wczbtf";
const StyledSvg = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'svg';
  return <Component ref={ref} {...restProps} className={classNames(styledSvgCss, props.className)} />;
});
export const Icon = ({
  selected,
  ...props
}) => <StyledSvg fill={selected ? primaryColorAlternative : textColorLevel2} viewBox="0 0 18 15" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path fillRule="evenodd" clipRule="evenodd" d={'M0 1.5C0 0.671573 0.671573 0 1.5 0' + 'H16.5C17.3284 0 18 0.671573 18 1.5C18 2.32843 17.3284 3 16.5 3' + 'H1.5C0.671573 3 0 2.32843 0 1.5ZM3 7.5C3 6.67157 3.67157 6 4.5 6' + 'H13.5C14.3284 6 15 6.67157 15 7.5C15 8.32843 14.3284 9 13.5 9' + 'H4.5C3.67157 9 3 8.32843 3 7.5ZM7.5 12C6.67157 12 6 12.6716 6 13.5C6 14.3284 6.67157 15 7.5 15' + 'H10.5C11.3284 15 12 14.3284 12 13.5C12 12.6716 11.3284 12 10.5 12H7.5Z'} />
  </StyledSvg>;

require("./icon.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./icon.js");